import getI18nProps from '@/utils/i18/getI18nProps';
import { styled } from '@mui/material/styles';
import MoonGame from '@/components/features/casino/crash';
import { Box } from '@mui/material';
import CatchError from '@/components/system/CacthError';

/* eslint-disable-next-line */
export interface CasinoCrashCrashProps {}

const StyledCasinoCrash = styled(Box)``;

// export const runtime = 'experimental-edge';
export function CasinoCrash(props: CasinoCrashCrashProps) {
  return <StyledCasinoCrash>{<MoonGame />}</StyledCasinoCrash>;
}

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await getI18nProps({ locale })),
    },
  };
}

export default CatchError(CasinoCrash);
